// NPM Imports
import React, { Fragment, useState, useEffect } from "react";
import Modal from "react-responsive-modal";
import { Link } from "react-router-dom";
import { Button, Toastr, NumberInput } from "@revvsales/components";

// Internal Imports
import { EVENTS, FEATURES } from "../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../utils";
import { sendFeatureRequest } from "../../actions/CommonActions/commonService";

// Destructuring
const { UPGRADE_TEXT } = FEATURES;
const { readDataFromLocalStorage } = GlobalUtils;

export default function UpgradePopUp(props) {
  // * LOCAL STATE DECLARATION SYNTAX

  const INITIAL_STATE = {
    phoneNumber: "",
    callBackSection: false,
  };
  const [state, setState] = useState(INITIAL_STATE);

  // * CDM
  useEffect(
    () => {
      const { displayName } = UPGRADE_TEXT[props.featureName];
      AmplitudeUtils.amplitudeLogEvent(
        EVENTS.EVENT_NAMES.PRO_FEATURE_ACCESSED,
        {
          featureName: `${displayName} request`,
        },
      );
    },
    [props.featureName],
  );

  function _onChange(field, value) {
    const stateClone = { ...state };
    stateClone[field] = value;
    setState(stateClone);
  }

  function _onSubmit() {
    const { displayName } = UPGRADE_TEXT[props.featureName];
    const body = `Hi Team,\n A user just requested a callback from the ${displayName} pro feature popup, below are the user details.\n Phone Number:${
      state.phoneNumber
    }`;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const {
      first_name: firstName,
      last_name: lastName,
      user_email: userEmail,
      organisation,
    } = CURRENT_USER;
    const data = {
      email: userEmail,
      orgname: organisation,
      subject: `${displayName} Call back request`,
      body,
      username: `${firstName} ${lastName}`,
    };
    sendFeatureRequest(data)
      .then(() => {
        props.onClose();
        if (displayName === "Export to MS Word (.docx)") {
          props.optionCloseList();
        }
        Toastr.showToastr({
          type: "success",
          message: "Successfully requested call back",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error("UpgradePopUp => _onSubmit", err);
      });
  }
  if (
    props.featureName &&
    Object.prototype.hasOwnProperty.call(UPGRADE_TEXT, props.featureName)
  ) {
    const { welcomeMsg, upsaleMsg, features } = UPGRADE_TEXT[props.featureName];
    return (
      <Modal
        open
        onClose={props.onClose}
        center
        closeOnOverlayClick={false}
        className="upgradepopup-modal-box">
        {/* ref is used here to handle scenario to ignore the click inside the element when parent has click event binded eg.export doc btn */}
        <div className="upgradepopup-container" ref={props.popupRef}>
          <section className="upgradepopup-info-section">
            <div className="upgradepopup-welcome-msg">{welcomeMsg}</div>
            <div className="upgradepopup-upsale-msg">{upsaleMsg}</div>
            <div className="upgradepopup-features">
              {features.map(feature => (
                <span key={feature}>{`✅ ${feature}`}</span>
              ))}
            </div>
          </section>
          <section className="upgradepopup-billing-section">
            <div className="upgradepopup-demo">
              <div>Need a demo of Team plan capabilities?</div>
              <div
                className="upgradepopup-demo-btn"
                onClick={() => _onChange("callBackSection", true)}
                onKeyPress={() => _onChange("callBackSection", true)}
                role="button"
                tabIndex="0">
                Request a call back
              </div>
            </div>

            <Link to="/settings/billing">
              <Button
                className=""
                onClick={() => props.onClose()}
                data-test="upgradepopup-gotobilling-btn">
                Go to billing
              </Button>
            </Link>
          </section>
          {state.callBackSection && (
            <section className="upgradepopup-callback-section">
              <div className="upgradepopup-callback-txt">
                Please enter your phone number and we will get in touch with you
                soon
              </div>
              <div className="upgradepopup-callback-actions-wrapper">
                <NumberInput
                  placeholder="Enter your phone number"
                  onChange={value => _onChange("phoneNumber", value)}
                  value={state.phoneNumber}
                  data-test="upgradepopup-phonenumber-input"
                />
                <div className="upgradepopup-callback-actions">
                  <Button
                    className="btn btn-primary upgradepopup-cancel-btn"
                    onClick={() => _onChange("callBackSection", false)}
                    data-test="upgradepopup-cancel-btn">
                    Cancel
                  </Button>

                  <Button
                    className="btn btn-primary upgradepopup-submit-btn"
                    onClick={() => _onSubmit()}
                    disabled={state.phoneNumber.length === 0}
                    data-test="upgradepopup-submit-btn">
                    Submit
                  </Button>
                </div>
              </div>
            </section>
          )}
        </div>
      </Modal>
    );
  }
  return <Fragment />;
}



// WEBPACK FOOTER //
// ./src/commonComponents/UpgradePopUp/index.js